import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MyApiClient from '../../../../../api-client/MyApiClient';
import { segnalaMancanti } from '../../../../components/Util/campiMancanti';

// Rotte per le prenotazioni manuali (tipi non "generico")
const ROUTE_PER_TIPO = {
    impianto: '/struttura/booking/userFacilities',
    lezione:  '/struttura/booking/userLessons',
    corso:    '/struttura/corsi/partecipanti/nuovo',
};

const api = new MyApiClient();

// ── Tipi evento ────────────────────────────────────────────────────
const TIPI = [
    {
        key: 'generico',  label: 'Generico',        sub: 'Evento libero non legato a impianti o maestri.',
        color: '#555',    bg: '#f5f5f5',
    },
    {
        key: 'impianto',  label: 'Impianto',         sub: 'Prenotazione o blocco di un impianto sportivo.',
        color: '#1565C0', bg: '#EBF2FC',
    },
    {
        key: 'lezione',   label: 'Lezione',          sub: 'Sessione con un maestro o istruttore.',
        color: '#FF9800', bg: '#FFF8E1',
    },
    {
        key: 'corso',     label: 'Corso e squadra',  sub: 'Allenamento, corso o attività di squadra.',
        color: '#00A15D', bg: '#E8F5EE',
    },
];

const TIPI_LABEL = {
    generico: 'evento generico',
    impianto: 'impianto',
    lezione:  'lezione',
    corso:    'corso e squadra',
};

// ── Overlay + card wrapper ─────────────────────────────────────────
function Modal({ onClose, children, width = 480 }) {
    return (
        <div
            onClick={onClose}
            style={{
                position: 'fixed', inset: 0,
                background: 'rgba(0,0,0,0.45)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                zIndex: 1000,
            }}
        >
            <div
                onClick={e => e.stopPropagation()}
                style={{
                    background: '#fff',
                    borderRadius: 12,
                    width, maxWidth: 'calc(100vw - 40px)',
                    maxHeight: 'calc(100vh - 60px)',
                    overflowY: 'auto',
                    boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
                }}
            >
                {children}
            </div>
        </div>
    );
}

// ── Step 1: scelta tipo ────────────────────────────────────────────
function Step1({ onClose, onNext }) {
    const [selected, setSelected] = useState('generico');

    return (
        <Modal onClose={onClose} width={460}>
            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 24px 16px' }}>
                <span style={{ fontSize: 16, fontWeight: 700, color: '#1a1a1a' }}>Crea nuovo evento</span>
                <button onClick={onClose} style={closeBtn}>✕</button>
            </div>

            <div style={{ height: 1, background: '#f0f0f0', margin: '0 24px' }} />

            {/* Type grid */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, padding: '20px 24px' }}>
                {TIPI.map(t => {
                    const active = selected === t.key;
                    return (
                        <div
                            key={t.key}
                            onClick={() => setSelected(t.key)}
                            style={{
                                border: `1.5px solid ${active ? t.color : '#e8e8e8'}`,
                                borderRadius: 8,
                                padding: '14px 14px 12px',
                                cursor: 'pointer',
                                background: active ? t.bg : '#fff',
                                transition: 'border-color 0.15s, background 0.15s',
                                position: 'relative',
                            }}
                        >
                            {active && (
                                <div style={{
                                    position: 'absolute', top: 10, right: 10,
                                    width: 18, height: 18, borderRadius: '50%',
                                    background: '#FF5E4B',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}>
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                                        <path d="M2 5l2.2 2.2L8 3" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                            )}
                            <div style={{ fontSize: 14, fontWeight: 700, color: active ? t.color : '#333', marginBottom: 5 }}>
                                {t.label}
                            </div>
                            <div style={{ fontSize: 12, color: '#999', lineHeight: 1.4 }}>
                                {t.sub}
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Footer */}
            <div style={{ padding: '0 24px 24px' }}>
                <button
                    onClick={() => onNext(selected)}
                    style={{
                        width: '100%', padding: '12px',
                        background: '#FF5E4B', color: '#fff',
                        border: 'none', borderRadius: 8,
                        fontSize: 14, fontWeight: 700, cursor: 'pointer',
                    }}
                >
                    Scegli e continua
                </button>
            </div>
        </Modal>
    );
}

// ── Step 2: form evento ────────────────────────────────────────────
function Step2({ tipo, onClose, token, onCreated, eventoToEdit }) {
    const t = TIPI.find(x => x.key === tipo);
    const isEdit = !!eventoToEdit;

    const today = new Date().toISOString().substring(0, 10);
    const initData      = eventoToEdit?.dataInizio ? eventoToEdit.dataInizio.substring(0, 10) : today;
    const initOraInizio = eventoToEdit?.dataInizio ? eventoToEdit.dataInizio.substring(11, 16) : '10:00';
    const initOraFine   = eventoToEdit?.dataFine   ? eventoToEdit.dataFine.substring(11, 16)   : '11:00';

    const [titolo,      setTitolo]      = useState(eventoToEdit?.titolo ?? '');
    const [data,        setData]        = useState(initData);
    const [oraInizio,   setOraInizio]   = useState(initOraInizio);
    const [oraFine,     setOraFine]     = useState(initOraFine);
    const [luogo,       setLuogo]       = useState(eventoToEdit?.luogo ?? '');
    const [descrizione, setDescrizione] = useState(eventoToEdit?.descrizione ?? '');
    const notifica = true;
    const [loading,     setLoading]     = useState(false);
    const [errore,      setErrore]      = useState('');

    // Invita persone — disabilitato temporaneamente
    // const [inviteInput, setInviteInput] = useState('');
    // const [invitati,    setInvitati]    = useState([]);
    // const addInvitato = () => {
    //     if (!inviteInput.trim()) return;
    //     setInvitati(p => [...p, { id: Date.now(), nome: inviteInput.trim() }]);
    //     setInviteInput('');
    // };

    const handleCrea = async () => {
        const mancanti = [];
        if (!titolo.trim()) mancanti.push({ campo: 'evento-titolo', messaggio: "Manca il nome dell'evento" });
        if (!data) mancanti.push({ campo: 'evento-data', messaggio: 'Manca la data' });
        if (!oraInizio) mancanti.push({ campo: 'evento-ora-inizio', messaggio: "Manca l'ora di inizio" });
        if (!oraFine) mancanti.push({ campo: 'evento-ora-fine', messaggio: "Manca l'ora di fine" });
        else if (oraInizio && oraFine <= oraInizio) mancanti.push({ campo: 'evento-ora-fine', messaggio: "L'ora di fine deve essere dopo l'inizio" });
        if (segnalaMancanti(mancanti) > 0) return;
        setErrore('');
        setLoading(true);
        const body = {
            type:       tipo,
            titolo:     titolo.trim(),
            dataInizio: `${data}T${oraInizio}:00`,
            dataFine:   `${data}T${oraFine}:00`,
            luogo:      luogo.trim() || undefined,
            descrizione: descrizione.trim() || undefined,
            notifica,
        };
        const res = isEdit
            ? await api.updateCalendarioEvento(token, eventoToEdit.id, body)
            : await api.createCalendarioEvento(token, body);
        setLoading(false);
        if (res?.error) { setErrore(res.error); return; }
        onCreated && onCreated();
        onClose();
    };

    return (
        <Modal onClose={onClose} width={500}>
            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 24px 16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ width: 10, height: 10, borderRadius: '50%', background: t.color, display: 'inline-block', flexShrink: 0 }} />
                    <span style={{ fontSize: 16, fontWeight: 700, color: '#1a1a1a' }}>
                        {isEdit ? `Modifica ${TIPI_LABEL[tipo]}` : `Nuovo ${TIPI_LABEL[tipo]}`}
                    </span>
                </div>
                <button onClick={onClose} style={closeBtn}>✕</button>
            </div>

            <div style={{ height: 1, background: '#f0f0f0', margin: '0 24px' }} />

            {/* Form body */}
            <div style={{ padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: 16 }}>

                {/* Nome evento */}
                <div>
                    <label htmlFor="evento-titolo" style={labelStyle}>Nome evento *</label>
                    <input id="evento-titolo" value={titolo} onChange={e => setTitolo(e.target.value)} placeholder="Nome evento" style={inputStyle} />
                </div>

                {/* Data / Inizio / Fine */}
                <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr 1fr', gap: 10 }}>
                    <div>
                        <label htmlFor="evento-data" style={labelStyle}>Data *</label>
                        <input id="evento-data" type="date" value={data} onChange={e => setData(e.target.value)} style={inputStyle} />
                    </div>
                    <div>
                        <label htmlFor="evento-ora-inizio" style={labelStyle}>Inizio *</label>
                        <input id="evento-ora-inizio" type="time" value={oraInizio} onChange={e => setOraInizio(e.target.value)} style={inputStyle} />
                    </div>
                    <div>
                        <label htmlFor="evento-ora-fine" style={labelStyle}>Fine *</label>
                        <input id="evento-ora-fine" type="time" value={oraFine} onChange={e => setOraFine(e.target.value)} style={inputStyle} />
                    </div>
                </div>

                {/* Luogo */}
                <div>
                    <label style={labelStyle}>Luogo</label>
                    <input value={luogo} onChange={e => setLuogo(e.target.value)} placeholder="Luogo (opzionale)" style={inputStyle} />
                </div>

                {/* Descrizione */}
                <div>
                    <label style={labelStyle}>Descrizione</label>
                    <input value={descrizione} onChange={e => setDescrizione(e.target.value)} placeholder="Descrizione (opzionale)" style={inputStyle} />
                </div>

                {/* Invita persone — disabilitato temporaneamente
                <div>
                    <label style={labelStyle}>Invita persone</label>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <input
                            value={inviteInput}
                            onChange={e => setInviteInput(e.target.value)}
                            onKeyDown={e => e.key === 'Enter' && addInvitato()}
                            placeholder="Nome o email"
                            style={{ ...inputStyle, flex: 1 }}
                        />
                        <button
                            onClick={addInvitato}
                            style={{ background: '#FF5E4B', color: '#fff', border: 'none', borderRadius: 6, padding: '0 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}
                        >
                            Invita
                        </button>
                    </div>
                </div>

                {invitati.length > 0 && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        {invitati.map(p => (
                            <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                <div style={{ width: 30, height: 30, borderRadius: '50%', background: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: '#666', flexShrink: 0 }}>
                                    {p.nome.charAt(0)}
                                </div>
                                <span style={{ flex: 1, fontSize: 13, color: '#333' }}>{p.nome}</span>
                                <button onClick={() => setInvitati(prev => prev.filter(x => x.id !== p.id))} style={{ background: 'none', border: 'none', color: '#FF5E4B', fontSize: 12, fontWeight: 600, cursor: 'pointer', padding: 0 }}>
                                    Rimuovi
                                </button>
                            </div>
                        ))}
                    </div>
                )}

                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, color: '#444' }}>
                    <div
                        onClick={() => setNotifica(p => !p)}
                        style={{ width: 16, height: 16, borderRadius: 3, border: `1.5px solid ${notifica ? '#FF5E4B' : '#ccc'}`, background: notifica ? '#FF5E4B' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, cursor: 'pointer' }}
                    >
                        {notifica && (
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                                <path d="M2 5l2.2 2.2L8 3" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        )}
                    </div>
                    Invia una notifica
                </label>
                */}

                {errore && <div style={{ fontSize: 12, color: '#FF5E4B', marginTop: -8 }}>{errore}</div>}
            </div>

            {/* Footer */}
            <div style={{ height: 1, background: '#f0f0f0', margin: '0 24px' }} />
            <div style={{ display: 'flex', gap: 10, padding: '16px 24px' }}>
                <button onClick={onClose} style={{ flex: 1, padding: '10px', background: '#fff', color: '#333', border: '1.5px solid #e0e0e0', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                    Annulla
                </button>
                <button
                    onClick={handleCrea}
                    disabled={loading}
                    style={{ flex: 1, padding: '10px', background: loading ? '#ffaa99' : '#FF5E4B', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: loading ? 'default' : 'pointer' }}
                >
                    {loading ? '...' : (isEdit ? 'Salva' : 'Crea')}
                </button>
            </div>
        </Modal>
    );
}

// ── Esportazione: gestisce lo step ────────────────────────────────
export default function CreaEventoModal({ onClose, token, onCreated, eventoToEdit }) {
    const [step, setStep] = useState(eventoToEdit ? 2 : 1);
    const [tipo, setTipo] = useState(eventoToEdit?.type ?? null);
    const navigate = useNavigate();

    const handleNext = (t) => {
        const route = ROUTE_PER_TIPO[t];
        if (route) {
            onClose();
            navigate(route);
            return;
        }
        setTipo(t);
        setStep(2);
    };

    if (step === 1) return <Step1 onClose={onClose} onNext={handleNext} />;
    return <Step2 tipo={tipo} onClose={onClose} token={token} onCreated={onCreated} eventoToEdit={eventoToEdit} />;
}

// ── Shared styles ─────────────────────────────────────────────────
const closeBtn = {
    background: 'none', border: 'none', cursor: 'pointer',
    fontSize: 16, color: '#aaa', padding: 4,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
};

const labelStyle = {
    display: 'block',
    fontSize: 12, fontWeight: 600, color: '#555',
    marginBottom: 5,
};

const inputStyle = {
    width: '100%', boxSizing: 'border-box',
    padding: '9px 12px',
    border: '1px solid #e0e0e0', borderRadius: 6,
    fontSize: 13, color: '#333', background: '#fff',
    outline: 'none',
};
